/** @jsxImportSource @emotion/react */

import { Modal } from "antd";
import { LIST_ICON_VIP } from "constants/list-vip";
import { ModalTypeValue } from "enums/modalType";
import { currency } from "helpers/formatCurrency";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { selectOpenModal, setOpenModal } from "store/master";
import { selectDataMemberVip } from "store/memberVip";

import { ModalVipStyle } from "./index.style";

export const ModalVip = () => {
  const dispatch = useAppDispatch();

  const openModal = useAppSelector(selectOpenModal);

  const { data: dataMemberVip } = useAppSelector(selectDataMemberVip);

  const dataVip = dataMemberVip?.board?.map((itemMap) => {
    return {
      ...itemMap,
      icon: LIST_ICON_VIP,
    };
  });

  return (
    <Modal
      className="modal__member-vip"
      open={openModal === ModalTypeValue.VIP}
      onCancel={() => {
        dispatch(setOpenModal(ModalTypeValue.CLOSE));
      }}
      css={ModalVipStyle.modal}
      footer={<></>}
      centered
    >
      <div css={ModalVipStyle.wrapper}>
        <h1>Điều kiện nâng cấp</h1>
        <div css={ModalVipStyle.self}>
          <table>
            <thead>
              <tr>
                <th>Cấp độ VIP</th>
                <th>Tích luỹ cược hợp lệ</th>
                <th>Tích luỹ tiền nạp</th>
                <th>Tiền thưởng nâng cấp</th>
                <th>Thưởng tháng</th>
                <th>Quà sinh nhật</th>
              </tr>
            </thead>

            <tbody>
              {dataVip?.map((itemMap) => {
                return (
                  <tr key={itemMap.id}>
                    <td>
                      <img alt="" src={itemMap.icon[Number(itemMap.id) - 1]} />
                    </td>
                    <td>{currency(Number(itemMap.max_turnover))}</td>
                    <td>{currency(Number(itemMap.max_deposit))}</td>
                    <td>{currency(Number(itemMap.level_up_bonus))}</td>
                    <td>{currency(Number(itemMap.montly_bonus))}</td>
                    <td>{currency(Number(itemMap.birthday_bonus))}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
};

export default ModalVip;
